import _extends from "@babel/runtime/helpers/extends";
import { useBlocker, BlockerContentInlineStyles, BlockerHeaderInlineStyles, BlockerFooterInlineStyles, BlockerHeader, BlockerFooter, BlockerBody, useWaitElementInViewport } from "../../..";
import { useRef, Fragment } from "react";
import { CONTEXT_LATEST_DESIGN_VERSION } from "../../types";
const BlockerTextContainer = _ref => {
  let {
    closeIcon
  } = _ref;
  const blocker = useBlocker();
  const {
    designVersion = CONTEXT_LATEST_DESIGN_VERSION,
    paintMode
  } = blocker;
  const ref = useRef();

  // Lazy load background image
  const isBackgroundVisible = paintMode === "instantInViewport" || useWaitElementInViewport(ref);
  return h("div", _extends({}, BlockerContentInlineStyles.inner(blocker), {
    ref: ref
  }), isBackgroundVisible && h("div", BlockerContentInlineStyles.innerBackground(blocker)), h("div", BlockerContentInlineStyles.content(blocker), h(BlockerHeader, {
    closeIcon: closeIcon
  }), h("div", BlockerHeaderInlineStyles.headerSeparator(blocker)), h(BlockerBody, null), designVersion === 1 && h(Fragment, null, h("div", BlockerFooterInlineStyles.footerSeparator(blocker)), h(BlockerFooter, null))));
};
export { BlockerTextContainer };